export const replaceAttachmentPath = (answer: string, apiHost: string) => {
  // Handle both absolute URLs and relative paths for attachments
  const absoluteRegex =
    /https:\/\/[^\/]+\/api\/attachments\.redirect(\?id=[^&\s]+)/g;
  const relativeRegex = /\/api\/attachments\.redirect(\?id=[^&\s]+)/g;

  // First replace absolute URLs
  let result = answer.replace(
    absoluteRegex,
    `${apiHost}/api/attachments.public.redirect$1`,
  );

  // Then replace relative paths
  result = result.replace(
    relativeRegex,
    `${apiHost}/api/attachments.public.redirect$1`,
  );

  return result;
};
